function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  r: 69,
  cy: 70,
  cx: 70,
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1, 1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M46.5,44.9l-0.2,39.7h7.1c1,4.4,4.9,7.8,9.7,7.8s8.7-3.3,9.7-7.8h8.8    c1,4.4,4.9,7.8,9.7,7.8c4.8,0,8.7-3.3,9.7-7.8h5.8V68.2L97.2,51H80.1v-6.1L46.5,44.9L46.5,44.9z M91.4,76.9c3.1,0,5.7,2.5,5.7,5.7    c0,3.1-2.6,5.7-5.7,5.7c-3.1,0-5.7-2.5-5.7-5.7S88.3,76.9,91.4,76.9z M80.1,55.2h14.7l7.9,14.2v11.1h-1.6c-1-4.4-4.9-7.8-9.7-7.8    c-4.8,0-8.7,3.3-9.7,7.8h-1.6C80.1,80.5,80.1,55.2,80.1,55.2z M63.3,76.9c3.1,0,5.7,2.5,5.7,5.7c0,3.1-2.5,5.7-5.7,5.7    c-3.1,0-5.7-2.5-5.7-5.7S60.1,76.8,63.3,76.9z M50.6,80.5l0.1-31.4l25.3,0v31.4h-3c-1-4.4-4.9-7.8-9.7-7.8s-8.7,3.3-9.7,7.8H50.6    L50.6,80.5z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  height: 4.1,
  width: 16.4,
  y: 50.1,
  x: 25.9
}), /*#__PURE__*/React.createElement("rect", {
  height: 4.1,
  width: 12.3,
  y: 75.5,
  x: 30
}), /*#__PURE__*/React.createElement("rect", {
  height: 4.1,
  width: 4.4,
  y: 75.5,
  x: 21.5
}), /*#__PURE__*/React.createElement("rect", {
  height: 4.1,
  width: 22,
  y: 62.8,
  x: 15.9
}));

function SvgEpLoad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 140 140",
    xmlSpace: "preserve",
    fill: "#FFFFFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpLoad);
export default __webpack_public_path__ + "static/media/ep-load.266e7061.svg";
export { ForwardRef as ReactComponent };